import { ajax } from './ajax'

//教学班级
//1、获取教学班级分页
export const reqClassList = (paramets) => ajax(`/jxclass/jxClass/list`, paramets)

//2、获取教学班级学生分页
export const reqClassStudentList = (paramets) => ajax(`/jxclass/jxClassStudent/customList`, paramets)

//3、获取教学班级分组
export const reqClassGroupList = (paramets) => ajax(`/jxclass/jxClassGroup/getGroupListById`, paramets)

//4、通过id删除教学班级学生
export const reqDelClassStudentById = (paramets) => ajax(`/jxclass/jxClassStudent/delete`, paramets, 'delete')

//5、通过id删除教学班级
export const reqDelClassById = (paramets) => ajax(`/jxclass/jxClass/delete`, paramets, 'delete')

//6、通过id删除教学班级分组
export const reqDelGroupById = (paramets) => ajax(`/jxclass/jxClassGroup/delete`, paramets, 'delete')

//7、通过id修改教学班级
export const reqBasicClassEditList = (paramets) => ajax(`/jxclass/jxClass/queryById`, paramets)

//8、批量删除教学班级
export const reqDelBatchClass = (paramets) => ajax(`/jxclass/jxClass/deleteBatch`, paramets, 'delete')

//10、批量分组
export const reqBatchGroupStu = (paramets) => ajax(`/jxclass/jxClassGroup/batchGroup`, paramets,"post")

//11、随机分组
export const reqBatchRandomStu = (paramets) => ajax(`/jxclass/jxClassGroup/randomGroup`, paramets,"post")

//12、修改+设置组长
export const reqEditGroupStu = (paramets) => ajax(`/jxclass/jxClassStudent/setLeader`, paramets,"post")

//13、批量删除教学班级分组学生
export const reqDelBatchClassGroupStu = (paramets) => ajax(`/jxclass/jxClassStudent/deleteBatch`, paramets, 'delete')

//14、获取行政班级
export const reqBasicClassList = () => ajax(`/bclass/basicClass/queryList`)

//15、通过id获取行政班级学生
export const reqUserByCId = (paramets) => ajax(`/jxclass/jxClass/getUserByCId`, paramets)

//16、获取教学班级学生
export const reqjxClassStudent = (paramets) => ajax(`/jxclass/jxClassStudent/queryList`, paramets)

//17、通过id获取教学班级学生

//18、从行政班级添加学生到教学班级
export const reqAddStudentTojxClass = (paramets) => ajax(`/jxclass/jxClass/addCS`, paramets, 'post')

//19、添加教学班级的分组
export const reqAddGroupTojxClass = (paramets) => ajax(`/jxclass/jxClassGroup/add`, paramets, 'post')

//20、教学班级学生单个分组
export const reqAddJxGroupStudent = (paramets) => ajax(`/jxclass/jxClassStudent/grouping`, paramets, 'post')

//21、修改教学班级的分组
export const reqEditGroupTojxClass = (paramets) => ajax(`/jxclass/jxClassGroup/edit`, paramets, 'put')

//22、从教学班级删除学生到行政班级
export const reqDelStudentTojxClass = (paramets) => ajax(`/jxclass/jxClass/removeCS`, paramets, 'post')

//18、从行政班级添加学生到教学班级
export const reqEditStudentTojxClass = (paramets) => ajax(`/jxclass/jxClass/editCS`, paramets, 'post')

//18、获取教室
export const reqGetclsOpts = (paramets) => ajax(`/wacom/basicWacomClassroom/list`, paramets)

//18、绑定教室
export const reqAddclsOpts = (paramets) => ajax(`/jxclass/jxClass/addWacomTeacher`, paramets, 'post')

//18、获取手写板列表
export const reqPadOpts = (paramets) => ajax(`/jxclass/jxClassStudent/residueList`, paramets)

//18、修改手写板
export const reqPadEdit = (paramets) => ajax(`/jxclass/jxClassStudent/edit`, paramets, 'put')

//18、选择教室
export const reqChoCls = (paramets) => ajax(`/wacom/basicWacomClassroom/openPadServe`, paramets,)

//18、解除手写板绑定
export const reqClearWacom = (paramets) => ajax(`/wacom/basicWacomClassroom/closePadServe`, paramets,)

//18、上课获取手写板个数
export const reqBoardCount = (paramets) => ajax(`/jxclass/jxClassStudent/queryPadStudent`, paramets,)


// WEBPACK FOOTER //
// ./src/api/jxClass.js